import React from 'react'
import Money from './Money'
import { Interweave } from 'interweave';
import ReactDOMServer from 'react-dom/server'
interface PriceProps {
  originalPrice: number,
  finalPrice: number,
  priceVaries: boolean,
  priceMin?: number,
  priceMax?: number,
  withCurrency?: boolean, //optionally use the shopify "with currency" format, eg. currency code after price
}

interface PriceVariationProps {
  priceMin: number,
  priceMax?: number
}

const PriceVariation: React.FC<PriceVariationProps> = ({ priceMin, priceMax }) => {
  const { fromTextHtml } = window['theme'].strings
  const { fromToTextHtml } = window['theme'].strings

  if (!isNaN(priceMin) && !isNaN(priceMax)) {
    const priceMaxString = ReactDOMServer.renderToStaticMarkup(<Money amount={priceMax} ></Money>)
    const priceMinString = ReactDOMServer.renderToStaticMarkup(<Money amount={priceMin} ></Money>)
    const text = fromToTextHtml.replace('[[price_max]]', priceMaxString).replace('[[price_min]]', priceMinString)
    return <Interweave content={text} noWrap={true} />
  }
  if (!isNaN(priceMin)) {
    const priceMinString = ReactDOMServer.renderToStaticMarkup(<Money amount={priceMin} ></Money>)
    const text = fromTextHtml.replace('[[price_max]]').replace('[[price]]', priceMinString)
    return <Interweave content={text} noWrap={true} />
  }
  return null

}


const Price = ({
  priceVaries,
  originalPrice,
  finalPrice,
  priceMin,
  priceMax,
  withCurrency,
} : PriceProps): JSX.Element => {
  // Use Global-E prices if available, otherwise fall back to original prices
  const displayFinalPrice = finalPrice;
  const displayOriginalPrice = originalPrice;
  const displayPriceMin = priceMin;
  const displayPriceMax = priceMax;

  return (
    <p className="product-price">
      { priceVaries && <PriceVariation priceMin={displayPriceMin || 0} priceMax={displayPriceMax} ></PriceVariation>}
      { !priceVaries && <>
        <span className={displayFinalPrice !== displayOriginalPrice ? 'price-variation' : ''}>
          <Money withCurrency={withCurrency} amount={displayFinalPrice} />
        </span>
        { displayFinalPrice !== displayOriginalPrice ? <s><Money amount={displayOriginalPrice} /></s> : null}
      </>}
    </p>
  )
}


export default Price